import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateRemoveSentModerationVacancy = {
  removeSentModerationVacancy: { data: null, loading: false, error: null },
};

export const removeSentModerationVacancy = createAsyncThunk('user/removeSentModerationVacancy', async (id, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .delete(`${process.env.REACT_APP_SERVER_API}/vacancies/${id}/moderation/to-employer`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerRemoveSentModerationVacancy = {
  [removeSentModerationVacancy.pending]: (state) => {
    state.removeSentModerationVacancy.loading = true;
    state.removeSentModerationVacancy.error = null;
  },
  [removeSentModerationVacancy.fulfilled]: (state, action) => {
    state.removeSentModerationVacancy.loading = false;
    state.removeSentModerationVacancy.data = action.payload;
    state.removeSentModerationVacancy.error = null;
  },
  [removeSentModerationVacancy.rejected]: (state, action) => {
    state.removeSentModerationVacancy.loading = false;
    state.removeSentModerationVacancy.error = action.payload;
  },
};
